export const TAB_NAMES = {
  GRAPHICS: 'DIAGRAM',
  CURRENT_VIEW: 'CURRENT VIEW',
  ELEMENTS: 'ELEMENTS',
  NETWORK: 'NETWORK',
} as const;
